import React from "react";

import CurrencyField from "../currency-field.jsx";
import { RaisedButton, TextField } from "material-ui";

class AddLineItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      description: "",
      amount: 0,
      fromInitialItem: false
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillReceiveProps(props) {
    if (props.initialItem) {
      this.setState({
        description: props.initialItem.description,
        amount: props.initialItem.amount,
        fromInitialItem: true
      });
    }
  }

  onSubmit() {
    this.props.onSubmit({
      description: this.state.description,
      amount: this.state.amount
    });
    this.setState({
      description: "",
      amount: 0,
      fromInitialItem: false
    });
  }

  render() {
    const { fromInitialItem } = this.state;

    return (
      <div
        style={{
          border: "1px dashed #ccc",
          borderRadius: "1em",
          padding: 10,
          marginTop: 30
        }}
      >
        {fromInitialItem ? (
          <div>Edit this Adjustment line item below.</div>
        ) : (
          <div>
            <strong>BillingGod: Need to make a tweak?</strong> Add a new
            Adjustment line item to the above invoice.
          </div>
        )}
        <div
          style={{ marginTop: -10, display: "flex", alignItems: "baseline" }}
        >
          <TextField
            style={{ flex: 1, marginRight: "1em" }}
            floatingLabelText="Description"
            floatingLabelFixed={true}
            value={this.state.description}
            onChange={e => this.setState({ description: e.target.value })}
            placeholder="Line item description"
            autoFocus={!!fromInitialItem}
          />
          <CurrencyField
            floatingLabelText="Amount"
            floatingLabelFixed={true}
            placeholder="$0.00"
            allowNegative
            style={{ width: 100, marginRight: "1em" }}
            value={this.state.amount}
            currency={this.props.currency}
            onChange={e =>
              this.setState({
                amount: e.target.value
              })
            }
          />
          <div style={{}}>
            <RaisedButton
              label={fromInitialItem ? "Update" : "Add to invoice"}
              disabled={!this.state.amount || !this.state.description}
              onClick={this.onSubmit}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default AddLineItem;



// WEBPACK FOOTER //
// ./src/app/components/partials/billing/add-line-item.jsx